import React, { useRef, useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion'
const HamBurg = () => {
    const [sideNav, setSideNav] = useState(false)
    const [isActive, setIsActive] = useState(false)
    const burger = useRef(null);

    const hamItems = [
        {
            name: " Home ",
            to: "/"
        },
        {
            name: " About ",
            to: "/about-me"
        },
        {
            name: " Work ",
            to: "/work"
        },
        {
            name: " Contact ",
            to: "/contact"
        },
    ]

    const setSide = () => {
        setSideNav(!sideNav)
    }

    const sideVariants = {
        inital: {
            right: '-100%',
            transition: {
                duration: 0.8,
                ease: [0.76, 0, 0.24, 1]
            }
        },
        animate: {
            right: '0%',
            transition: {
                duration: 0.8,
                ease: [0.76, 0, 0.24, 1]
            }
        },
        exit: {
            right: '-100%',
            transition: {
                duration: 0.8,
                ease: [0.76, 0, 0.24, 1]
            }
        }

    }

    return (
        <>
            <div className="hamBurger" ref={burger} onClick={() => setSide()}>
                <div className="lines">
                    <div className="hamLine"></div>
                    <div className="hamLine"></div>
                </div>
            </div>

            <AnimatePresence>
                <motion.div
                    variants={sideVariants}
                    initial="inital"
                    animate={sideNav ? "animate" : "inital"}
                    exit="exit"

                    className='sideNav'
                >
                    <div className="innerSide">

                        <div className="upper">

                            <div className="name">
                                <h3> Navigation </h3>
                                <div className="line"></div>
                            </div>

                            <ul className="options">
                                {
                                    hamItems.map((item, index) => (
                                        <motion.li
                                            onClick={() => { setIsActive(!isActive) }}
                                            whileHover={{ scale: 1.1 }}
                                            key={index}>

                                            <NavLink to={item.to} >
                                                <div className='circleHam' />
                                                {item.name}
                                            </NavLink>
                                        </motion.li>
                                    ))
                                }


                            </ul>
                        </div>

                        <div className="NavSocial">

                            <div className="name">
                                <h3> Social </h3>
                                <div className="line"></div>
                            </div>

                            <div className="navIcons">
                                <Link to={"https://discordapp.com/users/759284811239784468"} target='_blank' className='icon' >
                                    Discord
                                </Link>

                                <Link to={"https://github.com/Gagan-deepp"} target='_blank' className='icon'>
                                    Github
                                </Link>

                                <Link to={"https://www.linkedin.com/in/gagan-deep-singh-666158238"} target='_blank' className='icon' >
                                    Linkedin
                                </Link>

                            </div>
                        </div>
                    </div>
                </motion.div>
            </AnimatePresence>
        </>
    )
}

export default HamBurg